import {Layout, Anchor, Typography} from 'antd';
import React, {useState} from 'react';
import appColors from '../../style/theme';
import FTMCC from './FTMCC';
import IntroCC from './IntroCC';
import ResultsCC from './ResultsCC';

const {Link} = Anchor;
const {Sider, Content} = Layout;
const Text = Typography;

const handleClick = (e, link) => {
  e.preventDefault();
  console.log(link);
};
const ComputationaChemistyLogic = () => {
  const [backI, setBackI] = useState('transparent');
  const [backII, setBackII] = useState('transparent');
  const [backIII, setBackIII] = useState('transparent');
  const ChangeAnchor = (key) => {
    console.log(key);
    if (key === '#IntroCC') {
      setBackI(appColors['ColorE']);
      setBackII('transparent');
      setBackIII('transparent');
    } else if (key === '#FTCC') {
      setBackI('transparent');
      setBackII(appColors['ColorE']);
      setBackIII('transparent');
    } else if (key === '#ResultsCC') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII(appColors['ColorE']);
    }
  };
  return (
    <Layout style={{background: 'transparent'}}>
      <Sider style={{background: 'transparent'}}>
        <Anchor onClick={handleClick} offsetTop={75} onChange={ChangeAnchor} style={{background: 'transparent'}}>
          <Link href='#IntroCC' title={<Content className='ContentAnchor' style={{borderColor: backI}}><Text style={{color: appColors['ColorE'], fontSize: '3vh'}}>Introduction</Text></Content>}/>
          <Link href='#FTCC' title={<Content className='ContentAnchor' style={{borderColor: backII}}><Text style={{color: appColors['ColorE'], fontSize: '1.2vh'}}>Fundamentals and troubleshooting</Text></Content>}/>
          <Link href='#ResultsCC' title={<Content className='ContentAnchor' style={{borderColor: backIII}}><Text style={{color: appColors['ColorE'], fontSize: '1.7vh'}}>Results</Text></Content>}/>
        </Anchor>
        <p style={{color: appColors['ColorE'], pointerEvents: 'none', fontSize: '2vh', top: '65vh', left: '5vh', textAlign: 'center', position: 'sticky'}}> C&nbsp;<br/> O&nbsp;<br/> M&nbsp;<br/> P&nbsp;<br/> C&nbsp;<br/> H&nbsp;<br/> E&nbsp;<br/> M&nbsp;</p>
      </Sider>
      <Layout style={{margin: '1% 1% 0 1%', width: 'fit-content'}}>
        <Layout style={{background: appColors['ColorX'], height: '1px'}} />
        <Layout className='PurpBack' style={{background: appColors['ColorG']}}>
          <Layout style={{margin: '0 0 0 0', background: 'transparent'}}>
            <div id='IntroCC'>
              <IntroCC/>
            </div>
            <div id='FTCC'>
              <FTMCC/>
            </div>
            <div id='ResultsCC'>
              <ResultsCC/>
            </div>
          </Layout>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default ComputationaChemistyLogic;
